import { io } from "socket.io-client";
import type { Concert } from "../../static";
import type {
    Location,
    PlayData,
    SetConcertData,
    SetGlobalVolumeData,
    SetLocationData,
    StopAllData,
    StopData,
} from "../../server";

export interface SocketConfig {
    clientId: string;
    onchangeconnected: (connected: boolean) => void;
    onsetglobalvolume: (globalVolume: number) => void;
    onsetconcert: (concert: Concert | null) => void;
    onplay: (name: string, volume: number) => void;
    onstop: (name: string) => void;
    onstopall: () => void;
}

export const connectSocket = (config: SocketConfig) => {
    const socket = io(import.meta.env.VITE_SERVER_URL, {
        auth: { id: config.clientId },
    });

    socket.on("connect", () => {
        console.log("Connected to socket");
        config.onchangeconnected(true);
    });

    socket.on("disconnect", (reason, details) => {
        console.log("Disconnected from socket:", reason, details);
        config.onchangeconnected(false);
    });

    socket.onAny((event) => {
        console.log("Received message:", event);
    });

    socket.on("setGlobalVolume", ({ globalVolume }: SetGlobalVolumeData) => {
        config.onsetglobalvolume(globalVolume);
    });

    socket.on("setConcert", ({ concert }: SetConcertData) => {
        config.onsetconcert(concert as Concert | null);
    });

    socket.on("play", ({ audio, volume }: PlayData) => {
        config.onplay(audio, volume);
    });

    socket.on("stop", ({ audio }: StopData) => {
        config.onstop(audio);
    });

    socket.on("stopAll", ({}: StopAllData) => {
        config.onstopall();
    });

    return {
        setLocation: (location: Location) => {
            socket.emit("setLocation", { location } satisfies SetLocationData);
        },
    };
};

export type SocketMethods = ReturnType<typeof connectSocket>;
